<template>
<component :is="$vuetify.breakpoint.smAndUp ? 'v-container' : 'div'" fluid>
    <v-layout align-center justify-center wrap>
        <v-flex md4 pa-1>
            <v-card color="blue-grey darken-2" class="white--text" dark>
                <v-responsive :aspect-ratio="1/1">
                    <v-card-title primary-title>
                        <div>
                            <div class="headline">Unlimited music now</div>
                            <span>Listen to your favorite artists and albums whenever and wherever, online and offline.</span>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                        <v-btn text >Listen now</v-btn>
                    </v-card-actions>
                </v-responsive>
            </v-card>
        </v-flex>
        <v-flex md4 pa-1>
            <v-card color="cyan darken-2" class="white--text">
                <v-responsive :aspect-ratio="1/1">
                    <v-layout>
                        <v-flex xs5>
                            <v-img
                                    src="https://cdn.vuetifyjs.com/images/cards/foster.jpg"
                                    height="125px"
                                    contain
                            ></v-img>
                        </v-flex>
                        <v-flex xs7>
                            <v-card-title primary-title>
                                <div>
                                    <div class="headline">Supermodel</div>
                                    <div>Foster the People</div>
                                    <div>(2014)</div>
                                </div>
                            </v-card-title>
                        </v-flex>
                    </v-layout>
                    <v-divider light></v-divider>
                    <v-card-actions class="pa-3">
                        Rate this album
                        <v-spacer></v-spacer>
                        <v-icon>fas fa-star</v-icon>
                        <v-icon>fas fa-star</v-icon>
                        <v-icon>fas fa-star</v-icon>
                        <v-icon>fas fa-star</v-icon>
                        <v-icon>fas fa-star</v-icon>
                    </v-card-actions>
                </v-responsive>
            </v-card>
        </v-flex>
        <v-flex md4 pa-1>
            <v-card color="orange darken-2" class="white--text" dark>
                <v-responsive :aspect-ratio="1/1">
                    <v-card-title primary-title>
                        <div>
                            <div class="headline">Unlimited music now</div>
                            <span>Listen to your favorite artists and albums whenever and wherever, online and offline.</span>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                        <v-btn text >Listen now</v-btn>
                    </v-card-actions>
                </v-responsive>
            </v-card>
        </v-flex>
        <v-flex md4 pa-1>
            <v-card color="red darken-2" class="white--text">
                <v-responsive :aspect-ratio="1/1">
                    <v-layout>
                        <v-flex xs5>
                            <v-img
                                    src="https://cdn.vuetifyjs.com/images/cards/foster.jpg"
                                    height="125px"
                                    contain
                            ></v-img>
                        </v-flex>
                        <v-flex xs7>
                            <v-card-title primary-title>
                                <div>
                                    <div class="headline">Supermodel</div>
                                    <div>Foster the People</div>
                                    <div>(2014)</div>
                                </div>
                            </v-card-title>
                        </v-flex>
                    </v-layout>
                    <v-divider light></v-divider>
                    <v-card-actions class="pa-3">
                        Rate this album
                        <v-spacer></v-spacer>
                        <v-icon>fas fa-star</v-icon>
                        <v-icon>fas fa-star</v-icon>
                        <v-icon>fas fa-star</v-icon>
                        <v-icon>fas fa-star</v-icon>
                        <v-icon>fas fa-star</v-icon>
                    </v-card-actions>
                </v-responsive>
            </v-card>
        </v-flex>
        <v-flex md4 pa-1>
            <v-card color="purple darken-2" class="white--text" dark>
                <v-responsive :aspect-ratio="1/1">
                    <v-card-title primary-title>
                        <div>
                            <div class="headline">Unlimited music now</div>
                            <span>Listen to your favorite artists and albums whenever and wherever, online and offline.</span>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                        <v-btn text >Listen now</v-btn>
                    </v-card-actions>
                </v-responsive>
            </v-card>
        </v-flex>
    </v-layout>
     </component>

</template>

<script>
    export default {
        name: "dashboard-index"
    }
</script>

<style scoped>

</style>